import { compose, pipe } from 'ramda'
import BookingProduct from '@v/bookings/edit/models/BookingProduct.js'
import { Success, Failure, chain } from 'folktale/validation'
import { validateProps } from './mapUtils.js'
import { makeBookingProduct } from './makeBookingProduct.js'

export const mapNonScheduledBookingProducts = products =>
  pipe(
    parseAndValidate,
    x => x.map(joinProduct(products)),
    x => chain(x, addProductFields),
    // x => x.map(v => new BookingProduct(v)),
  )

const validateParsedObject = validateProps([
  'productKey', // The product this bookingproduct belongs to
  'productGroupKey', // The deal this bookingproduct belongs to
  'dealId',
])

const parseAndValidate = compose(validateParsedObject, JSON.parse)

const joinProduct = products => value => {
  return {
    ...value,
    product: products.find(p => p.Key === value.productKey),
  }
}

const addProductFields = value =>
  value.product
    ? Success(makeBookingProduct(value))
    : Failure([`Could not find product with key ${value.productKey}`])
